
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-brand-blue text-white pt-12 pb-8 mt-12 border-t-4 border-brand-yellow rounded-t-3xl shadow-lg">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          <div className="space-y-4 md:pr-6">
            <h3 className="text-xl font-bold">CareerGuideKerala</h3>
            <p className="text-gray-300 text-sm">
              Providing expert career guidance for students in Kerala, helping you make informed decisions about your future.
            </p>
          </div>
          
          <div className="space-y-4">
            <h4 className="text-lg font-semibold">Quick Links</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-gray-300 hover:text-white text-sm transition-colors duration-200">Home</Link></li>
              <li><Link to="/assessment" className="text-gray-300 hover:text-white text-sm transition-colors duration-200">Career Assessment</Link></li>
              <li><Link to="/login" className="text-gray-300 hover:text-white text-sm transition-colors duration-200">Login</Link></li>
              <li><Link to="/signup" className="text-gray-300 hover:text-white text-sm transition-colors duration-200">Sign Up</Link></li>
              <li><Link to="/faq" className="text-gray-300 hover:text-white text-sm transition-colors duration-200">FAQ</Link></li>
            </ul>
          </div>
          
          <div className="space-y-4">
            <h4 className="text-lg font-semibold">Policies</h4>
            <ul className="space-y-2">
              <li><Link to="/privacy-policy" className="text-gray-300 hover:text-white text-sm transition-colors duration-200">Privacy Policy</Link></li>
              <li><Link to="/terms-and-conditions" className="text-gray-300 hover:text-white text-sm transition-colors duration-200">Terms & Conditions</Link></li>
              <li><Link to="/cancellation-refund" className="text-gray-300 hover:text-white text-sm transition-colors duration-200">Cancellation & Refund</Link></li>
              <li><Link to="/shipping-delivery" className="text-gray-300 hover:text-white text-sm transition-colors duration-200">Shipping & Delivery</Link></li>
            </ul>
          </div>
          
          <div className="space-y-4">
            <h4 className="text-lg font-semibold">Contact Us</h4>
            <ul className="space-y-2 text-sm">
              <li className="text-gray-300">Email: careerguidekerala@gmail.com</li>
              <li className="text-gray-300">Phone: +91 7909111007</li>
              <li className="text-gray-300">Address: Ernakulam, Kerala, India</li>
              <li><Link to="/contact-us" className="text-gray-300 hover:text-white text-sm transition-colors duration-200">Contact Page</Link></li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-gray-700 pt-6 text-center">
          <p className="text-sm text-gray-300">
            &copy; {new Date().getFullYear()} CareerGuideKerala. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
